module.exports = __webpack_public_path__ + "static/media/weatherForecast.2324fde0.md";